import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import CustomersData from "../../components/Customers/CustomerList";

const Customers =() => {
    return(
      <>
     {/* <Breadcrumb /> */}
       <CustomersData/>
       </>
       );
};
export default Customers;